import React from 'react';
import { MenuItemProps } from '@material-ui/core/MenuItem';
import { StyledMenuItem } from './style';

const MenuItem: React.FC<MenuItemProps> = function (props) {
  return <StyledMenuItem {...props} />;
};

export default MenuItem;
